<script>
import Layout from '@layouts/main.vue'
import analyticsService from '@utils/analytics-service'

export default {
  page: {
    title: 'How-To Pushover',
    meta: [{ name: 'description', content: 'The Howto Pushover page.' }],
  },
  components: { Layout },
  mounted() {
    analyticsService.trackPageView('How-To Pushover')
  },
}
</script>

<template>
  <Layout>
    <img
      :class="$style.pushoverHeader"
      src="@assets/images/pushover_header.png"
    />
    <p
      >Pushover is an app the allows you to receive Push Notifications from
      various services. For our purposes we think it's a great fit because</p
    >
    <ul>
      <li
        >It can open links immediately upon activating a notification. No more
        fumbing to get to the product. Just tap the notification and add it to
        your cart (if we didn't already do that for you)</li
      >
      <li
        >It can send "Critical Notifications". This means you can have you phone
        on mute, on Do Not Disturb, whatever, and it will still play a sound and
        notify you. This is optional within Pushover of course, but we highly
        recommend it.</li
      >
      <li
        >Push Notifications are among the fastest ways to receive personal
        notifications, and in a game of seconds, that's what you need.</li
      >
    </ul>
    <div>
      <h3>Setup</h3>
      <div>
        <h4>1. Get the app</h4>
        <a href="https://pushover.net/clients/android">
          <img
            :class="$style.appLogo"
            src="@assets/images/google_play_logo.png"
          />
        </a>
        <a href="https://pushover.net/clients/ios">
          <img
            :class="$style.appLogo"
            src="@assets/images/app_store_logo.png"
          />
        </a>
      </div>
      <div>
        <h4>2. Create an account</h4>
      </div>
      <div>
        <h4>3. Get your user key</h4>
        <img
          :class="$style.appScreenshot"
          src="@assets/images/pushover_user_key.jpg"
        />
      </div>
      <div>
        <h4>4. Enter your user key on the Settings page</h4>
      </div>
      <div>
        <h4>5. (Optional) Power User Settings</h4>
        <ol
          ><li
            >Set browser as Safari on iOS (so you can use Apple Pay) or Chrome
            on Android (so you can use Google Pay)</li
          ><li>Enable "Auto Open URLs"</li
          ><li>Enable "Critical Alerts for high-priority"</li></ol
        >
        <img
          :class="$style.appScreenshot"
          src="@assets/images/pushover_settings.gif"
        />
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.pushoverHeader {
  width: 200px;
}

.appLogo {
  width: 172px;
}

.appScreenshot {
  max-width: 350px;
}
</style>
